import { render } from "./Home.vue?vue&type=template&id=01ec1834&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=01ec1834&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec1834"]])

export default __exports__